import React, { memo } from 'react'

import GenericPolygonTypeSelector from 'Pods/ThreeDStudio/Shared/GenericPolygonTypeSelector/GenericPolygonTypeSelector'
import { setPolygonType } from 'Pods/ThreeDStudio/Store/actions/remeshSettings'
import { POLYGON_TYPE } from 'Pods/ThreeDStudio/Store/constants'

const handleQuadrilateralClick = () => setPolygonType(POLYGON_TYPE.QUADRILATERAL)
const handleTriangleClick = () => setPolygonType(POLYGON_TYPE.TRIANGLE)

function PolygonTypeSelector() {
  return (
    <GenericPolygonTypeSelector
      handleQuadrilateralClick={handleQuadrilateralClick}
      handleTriangleClick={handleTriangleClick}
      sliceName="remeshSettings"
      storeSchemaKey="enhancedModelSchema"
    />
  )
}

export default memo(PolygonTypeSelector)
